import { MfaVerificationRequest } from '@_types/shared/Mfa';
import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { clearMfaToken } from 'lib/src/utils/jwt';
import { AppDispatch } from 'src/redux/store';

export const postMfaVerificationRequest = createAction('postMfaVerificationRequest');
export const postMfaVerificationSuccess = createAction('postMfaVerificationSuccess');
export const postMfaVerificationFailure = createAction('postMfaVerificationFailure');

export const postMfaVerification =
    (postbody: MfaVerificationRequest, hasMfa: boolean) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(postMfaVerificationRequest());

        try {
            const { data }: MfaVerificationResponseModel = await api.post(
                `admin/${hasMfa ? 'auth' : 'profile'}/mfa/verify`,
                postbody,
                undefined,
                { auth: 'mfa' },
            );

            localStorage.setItem('token', data.token);
            clearMfaToken();

            dispatch(postMfaVerificationSuccess());
        } catch (e) {
            handleApiErrors(dispatch, postMfaVerificationFailure, e);
        }
    };

interface MfaVerificationResponseModel {
    data: { token: string; hasMfa: boolean; mfaToken: null };
}
